import { z } from 'zod';

/**
 * Postal address used by `seller`/`buyer` blocks of an `InvoiceBlob`.
 *
 * Most fields are optional because low ZUGFeRD profiles (MINIMUM/BASIC) and
 * heuristic LLM extraction may not provide every line. `country` is a 2-letter
 * ISO 3166-1 alpha-2 code when present.
 */
export const AddressSchema = z.object({
  street: z.string().optional(),
  city: z.string().optional(),
  postalCode: z.string().optional(),
  state: z.string().optional(),
  country: z
    .string()
    .length(2)
    .regex(/^[A-Z]{2}$/, 'country must be ISO 3166-1 alpha-2 (e.g. "DE")')
    .optional(),
});

export type Address = z.infer<typeof AddressSchema>;
